const LE_CARD_NUMBER_LENGTH = 16

export const isBlackhwakCard = (code: string): boolean => {
  if (code.length === LE_CARD_NUMBER_LENGTH && code.match(/[0-9]{16}/)) {
    return true
  }
  return code.length > LE_CARD_NUMBER_LENGTH
}
